import { string, struct } from 'io-ts/Decoder';

export const Request = struct({
	name: string,
});
